import Route from 'cio/routes/base';
import TransactionalMessageModel from 'cio/models/transactional-message';
import TransactionalMessageSetupIndexController from 'cio/pods/transactional/message/setup/index/controller';
import Transition from '@ember/routing/-private/transition';
import isDestroyed from 'cio/utils/is-destroyed';

export default class TransactionalMessageSetupIndex extends Route {
  resetController(controller: TransactionalMessageSetupIndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      let model = this.modelFor(this.routeName) as TransactionalMessageModel;
      if (!isDestroyed(model)) {
        model.rollbackAttributes();
      }
    }
  }
}
